import { gameLeave } from '@/api/game'
import { showNotice, showConfirm } from '@/utils/tool'
import store from 'vuex-store/index'
import i18n from '@/i18n'

// type = game or provider
export function gameStart(type, gameOrProvider) {
  if (!store.getters.token) {
    // 未登入
    store.commit('SET_LOGIN_OPEN', true)
  } else if (type === 'game' && gameOrProvider.status === 2) {
    // 遊戲維護中
    showNotice(i18n.t('Bao.game_maintenance'))
  } else {
    // 檢查用戶是否開啟自動上分
    if (store.getters.memberInfo.auto_to_game !== 1) {
      const gameProviderId = type === 'provider' ? gameOrProvider.id : gameOrProvider.game_provider_id
      // 彈出確認視窗
      showConfirm(i18n.t('Bao.please_select_game_method'), i18n.t('Bao.to_game_directly'), i18n.t('Bao.to_game_transfer'), function() {
        store.dispatch('launchGame', { type, gameOrProvider })
      }, function() {
        showGameWalletModal(gameProviderId, 'in', () => {
          store.dispatch('launchGame', { type, gameOrProvider })
        })
      })
    } else {
      // 實際進入遊戲
      store.dispatch('launchGame', { type, gameOrProvider })
    }
  }
}

export function gameEnd(game_id) {
  if (!store.getters.token) {
    return
  }
  // loading開始
  store.commit('SET_LOADING', true)

  store.commit('SET_IN_GAME_ID', null)
  if (game_id) {
    showNotice('closeModal')

    gameLeave(game_id).then(response => {
      // 寫入遊戲餘額
      const current = store.getters.gameBalance
      const gameBalance = response.data.data
      current[gameBalance.game_provider_id] = gameBalance
      store.commit('SET_GAME_BALANCE_INFO', current)

      // loading結束
      store.commit('SET_LOADING', false)
      store.commit('SET_CURRENT_GAME', {})
    })
  } else {
    store.commit('SET_LOADING', false)
    store.commit('SET_CURRENT_GAME', {})
  }
}

export function showGameWalletModal(gameProviderId, fixType, callback) {
  const data = {
    gameProviderId: gameProviderId,
    fixType: fixType === undefined ? false : fixType,
    callback: callback
  }

  store.commit('SET_GAME_WALLET_MODAL', data)
}

export function hideGameWalletModal() {
  store.commit('SET_GAME_WALLET_MODAL', false)
}

export function initializeGamePreferences() {
  const gameTypes = store.state.game.gameType || []
  const gamePreferences = {}

  gameTypes.forEach(gameTypeObj => {
    gamePreferences[gameTypeObj.game_type] = {
      dontShow: false
    }
  })

  localStorage.setItem('gameModalPreferences', JSON.stringify(gamePreferences))
}
